function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "trending_dark",
  d: "M90.357,253.168H82.465a1.842,1.842,0,0,0,0,3.684H85.91l-7.87,7.869-4.278-4.278a1.842,1.842,0,0,0-2.6,0l-4.186,4.185a1.842,1.842,0,1,0,2.6,2.605l2.883-2.883,4.277,4.278a1.842,1.842,0,0,0,2.605,0l9.172-9.171V262.9a1.842,1.842,0,0,0,3.684,0V255.01A1.842,1.842,0,0,0,90.357,253.168Zm0,0",
  transform: "translate(-65.261 -252.168)",
  fill: "none",
  stroke: "#4a5662",
  strokeWidth: 2
});

function SvgTrendingDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.938,
    height: 18,
    viewBox: "0 0 27.938 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDark);
export default __webpack_public_path__ + "static/media/trending_dark.1192d18f.svg";
export { ForwardRef as ReactComponent };